import { queryOptions } from '@tanstack/react-query';

import { RQ_BRAND_CATEGORY_PAGE_METADATA_KEY } from '../ReactQuery/cacheKeys';

import { getContentfulData } from '@/modules/cms/api';
import { type CMSPageMetadataCollectionResponse } from '@/modules/cms/types';

export function brandCategoryPageMetadataQueryOptions(
  brandCategoryPath: string
) {
  const query = `query {
      webBrandCategoryCollection (where: {slug: "${brandCategoryPath}"}) {
        items {
          title,
          copy,
          seo {
            metaTitle,
            metaDescription,
            canonicalLink
          }
        }
      }
    }`;

  return queryOptions({
    queryKey: [RQ_BRAND_CATEGORY_PAGE_METADATA_KEY, brandCategoryPath],
    queryFn: async () => {
      const { data } =
        await getContentfulData<CMSPageMetadataCollectionResponse>({
          query,
          cache: 'force-cache',
        });
      return data?.data.webBrandCategoryCollection?.items?.[0] || {};
    },
  });
}
